import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link, Redirect } from 'react-router-dom'
import moment from 'moment';
import { Modal } from "react-bootstrap";
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'
import Select from 'react-select';
import { Pagination } from 'antd';

import { setCookie, getCookie } from '../common_component/cookie.js';
import StatusBadge from "../common_component/StatusBadge.js";
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";
import PageLoader from "../common_component/PageLoader.js";

const EcommerceDeliveryChallanList = () => {
    const [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme();

    const [deliveryChallanList, setDeliveryChallanList] = useState([])
    const [listCount, setListCount] = useState(0)
    const [searchValue, setSearchValue] = useState(null)
    const [startDate, setStartDate] = useState(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"))
    const [deliveryChallanListApiState, setDeliveryChallanListApiState] = useState(false)

    const [warehouseProcessingList, setWarehouseProcessingList] = useState([])
    const [warehouseProcessingListApiState, setWarehouseProcessingListApiState] = useState(false)

    const [timezone_change, set_timezone_change] = useState("+00:00");

    const [itemsModalShow, setItemsModalShow] = useState(false)
    const [itemsData, setItemsData] = useState([])

    const [current_page, setCurrent_page] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [statusType, setStatusType] = useState({ label: "All", value: "All" });

    const [invoiceSelectionModalShow, setInvoiceSelectionModalShow] = useState(false)
    const [selectedInvoice, setSelectedInvoice] = useState(null)

    const daterange_picker_ref = useRef()

    var page_name = "ecommerce-delivery-challan-list";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    const presets = [
        { label: 'Today', start: new Date(), end: new Date() },
        { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
        { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
        { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
    ];

    async function getDeliveryChallanList(signal, sd, ed, page_number, size, search_val, st) {
        setDeliveryChallanListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-delivery-challan-list`, { signal, method: 'POST', body: JSON.stringify({ "email": user.email, "start_date": sd, "end_date": ed, "current_page": page_number - 1, "rows_per_page": size, "search_value": search_val, "status_type": st, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation == "success") {
            setDeliveryChallanList(body.data.list);
            setListCount(body.data.count)
            setDeliveryChallanListApiState(false)
        }
        else {
            throw "basic warehouse processing list api error"
        }
    }

    async function getTimezoneInformation() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            if (body.data.length > 0) {
                if (body.data[0].timezone_value != "" && body.data[0].timezone_value != null) {
                    const timezone = body.data[0].timezone_value;
                    set_timezone_change(timezone);
                    setStartDate(moment().utcOffset(timezone).subtract(6, "days").format("YYYY-MM-DD"));
                    setEndDate(moment().utcOffset(timezone).format("YYYY-MM-DD"));
                }
                else {
                    setStartDate(moment.utc().subtract(6, "days").format("YYYY-MM-DD"));
                    setEndDate(moment.utc().format("YYYY-MM-DD"));
                }
            }
            else {
                setStartDate(moment.utc().subtract(6, "days").format("YYYY-MM-DD"));
                setEndDate(moment.utc().format("YYYY-MM-DD"));
            }
        }
        else {
            throw "timezone api error"
        }
    }

    async function getWarehouseProcessingBySearch(val) {
        setWarehouseProcessingListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-warehouse-processing-by-search`, { method: 'POST', body: JSON.stringify({ search_value: val, "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        setWarehouseProcessingList(body.data)
        setWarehouseProcessingListApiState(false)
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            const controller = new AbortController();
            const signal = controller.signal;
            let p1 = getDeliveryChallanList(signal, startDate, endDate, current_page, pageSize, searchValue, statusType.value);
            let p2 = getTimezoneInformation();
            let p3 = getWarehouseProcessingBySearch("");

            Promise.all([p1, p2, p3])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((errx) => {
                    console.log(errx)
                    setstate(3)
                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            const controller = new AbortController();
            const signal = controller.signal;

            getDeliveryChallanList(signal, startDate, endDate, current_page, pageSize, searchValue, statusType.value)

            return () => {
                controller.abort();
            };
        }
    }, [startDate, endDate, current_page, pageSize, searchValue, statusType.value])

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Ecommerce Delivery Challan List</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <button className="btn btn-sm btn-primary" data-kt-indicator={state !== 1 ? "on" : "off"} disabled={state !== 1} onClick={() => { setInvoiceSelectionModalShow(true) }}>
                            <span className="indicator-label"><i className="bi bi-plus-circle"></i>Create New Challan</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </div>

                <div>
                    {
                        state == 2 ?
                            <PageLoader />
                            :
                            state == 1 ?
                                <>
                                    <div className="row gx-0 gap-5 m-2">
                                        <div className='col-md-4'>
                                            <div className="d-flex align-items-center gap-5 mx-5 my-2">
                                                <div className=''>
                                                    <DateRangePickerComponent
                                                        ref={daterange_picker_ref}
                                                        allowEdit={false}
                                                        presets={presets}
                                                        showClearButton={false}
                                                        focus={() => { daterange_picker_ref.current.show() }}
                                                        delayUpdate={true}
                                                        change={(e) => {
                                                            setStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                                            setEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                                                        }}
                                                        startDate={new Date(startDate)}
                                                        endDate={new Date(endDate)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card mb-5 mb-xl-8">
                                        <div className="card-body pt-6">
                                            <div className='mb-5'>
                                                <input type="text" className='form-control fw-bold border border-primary' value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }} placeholder='Search...' />
                                            </div>
                                            <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                                <div className="mb-5 d-flex justify-content-center">
                                                    <Pagination
                                                        total={listCount}
                                                        onChange={(page, pageSize) => {
                                                            setCurrent_page(page);
                                                            setPageSize(pageSize);
                                                        }}
                                                        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                                                        defaultPageSize={pageSize}
                                                        defaultCurrent={current_page}
                                                        showSizeChanger={true}
                                                    />
                                                </div>
                                                <div className='overflow-auto w-100 flex-grow-1'>
                                                    <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" style={{ minWidth: "1000px" }}>
                                                        <thead>
                                                            <tr className="fw-bold text-muted">
                                                                <th className="min-w-120px">Chalan Number</th>
                                                                <th className="min-w-120px">Chalan Type</th>
                                                                <th className="min-w-150px">Order ID</th>
                                                                <th className="min-w-130px">Order Number</th>
                                                                <th className="min-w-130px">Items</th>
                                                                <th className="min-w-120px">Added By</th>
                                                                <th className="min-w-140px">Date</th>
                                                                <th className="min-w-120px">Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                deliveryChallanListApiState ?
                                                                    <tr>
                                                                        <td colSpan={7} className="text-center pt-10">
                                                                            <div className="spinner-border text-primary"></div>
                                                                        </td>
                                                                    </tr>
                                                                    :
                                                                    deliveryChallanList.length > 0 ?
                                                                        deliveryChallanList.map((obj3, indx3) => {
                                                                            return (
                                                                                <tr key={indx3}>
                                                                                    <td><a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6 d-flex align-items-center gap-2">{obj3.ecom_delivery_challan_number}<Link to={{ pathname: `/view-ecommerce-order/${obj3.order_id}`, state: { activeTab: 'associated_challans' } }}><i className="fa-solid fa-eye fs-2 p-0 text-hover-primary cursor-pointer"></i></Link></a></td>
                                                                                    <td><span className={`badge badge-secondary`} >{obj3.challan_type}</span></td>
                                                                                    <td><a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.ref_order_id}</a></td>
                                                                                    <td><a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6 d-flex align-items-center gap-2">{obj3.order_number}<Link to={`/view-ecommerce-order/${obj3.order_id}`}><i className="fa-solid fa-eye fs-2 p-0 text-hover-primary cursor-pointer"></i></Link></a></td>
                                                                                    <td><button className="btn btn-info fs-8 px-3 py-2 rounded" onClick={() => { setItemsModalShow(true); setItemsData(obj3.item_array) }}>View</button></td>
                                                                                    <td><a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.user_id}</a></td>
                                                                                    <td><a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{moment(obj3.add_date_time).utcOffset(timezone_change).format("ll")}</a></td>
                                                                                    <td><StatusBadge status={obj3.add_status} entity={"ECOMMERCE_DELIVERY_CHALLAN"} /></td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                        :
                                                                        <tr>
                                                                            <td colSpan={7} className="text-center">
                                                                                <h3 className="text-muted pt-6">No data to be shown</h3>
                                                                            </td>
                                                                        </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="mt-5 d-flex justify-content-center">
                                                    <div className="card-toolbar">
                                                        <Pagination
                                                            total={listCount}
                                                            onChange={(page, pageSize) => {
                                                                setCurrent_page(page);
                                                                setPageSize(pageSize);
                                                            }}
                                                            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                                                            defaultPageSize={pageSize}
                                                            defaultCurrent={current_page}
                                                            showSizeChanger={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                                :
                                state == 3 ?
                                    <PageError>
                                        <div className="notice bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                            <h4 className="text-gray-800 fw-bolder">Create a new Ecommerce Invoice</h4>
                                            <div className='mt-10 text-center'>
                                                <Link className='btn btn-success rounded' to={`/create-ecommerce-invoice`}>Create an Invoice</Link>
                                            </div>
                                        </div>
                                    </PageError>
                                    :
                                    <PageError>
                                        <div className="notice bg-light-danger rounded border-primary border border-dashed rounded-3 p-6">
                                            <h4 className="text-gray-800 fw-bolder">Something went wrong</h4>
                                            <div className='mt-10 text-center'>
                                                <button className='btn btn-success rounded' onClick={() => { window.location.reload() }}>Reload the page</button>
                                            </div>
                                        </div>
                                    </PageError>
                    }
                </div>
            </div>



            <Modal show={itemsModalShow} onHide={() => { setItemsModalShow(false); setItemsData([]); }} centered>
                <Modal.Header>
                    <Modal.Title>Total Items: {itemsData.length}</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setItemsModalShow(false); setItemsData([]); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        {
                            itemsData.map((obj, indx) => {
                                return (
                                    <div key={indx}>
                                        <span className='fw-bold fs-5'><span className="bullet bg-primary me-2"></span>{obj.item_name + " - (" + obj.warehouse_list.reduce((acc, curr) => acc + curr.quantity, 0) + ")"}</span>
                                    </div>
                                )
                            })
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary rounded" onClick={() => { setItemsModalShow(false); setItemsData([]); }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={invoiceSelectionModalShow} onHide={() => { setInvoiceSelectionModalShow(false); }} centered>
                <Modal.Header>
                    <Modal.Title>Choose an Invoice to proceed</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setInvoiceSelectionModalShow(false); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <Select
                            options={warehouseProcessingList.map(x => { return { label: x.invoice_number, value: x.warehouse_processing_id } })}
                            onChange={(val) => { setSelectedInvoice(val) }}
                            onInputChange={(val) => { getWarehouseProcessingBySearch(val) }}
                            value={selectedInvoice}
                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                            placeholder="Search for an Invoice"
                            isLoading={warehouseProcessingListApiState}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary rounded" onClick={() => { setInvoiceSelectionModalShow(false); }}>Close</button>
                    <button className="btn btn-success rounded" onClick={() => {
                        selectedInvoice == null ? swal("Alert", "Select an Invoice before proceeding", "warning")
                            :
                            window.location.href = `/create-ecommerce-delivery-challan/${selectedInvoice.value}`
                    }}>Proceed</button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default EcommerceDeliveryChallanList;
